export default __webpack_public_path__ + "static/media/loc-arte-1.edf3b9e1.webp";